<template>
	<div class="trade">
		<!--底部导航栏 -->
		<van-tabbar v-model="active" replace inactive-color="#222222" active-color="#f24d38" :z-index="2020">
			<van-tabbar-item icon="home-o" to="/Home">首页</van-tabbar-item>
			<!-- <van-tabbar-item icon="comment-o" @click="open53()">在线咨询</van-tabbar-item> -->
			<van-tabbar-item @click="toQuick('/Quick')">
				<div class="van-tabbar-img">
					<img src="../assets/add.png" alt="">
				</div>
				<div class="van-tabbar-item__text">卖闲具</div>
			</van-tabbar-item>
			<van-tabbar-item icon="contact" @click="toQuick('/idle')">我的</van-tabbar-item>
		</van-tabbar>
		<!--登录 -->
		<van-popup v-model="show" position="bottom" :style="{ height: '100%' }" :z-index="4000">
			<div class="close-icon" @click="show=false">关闭</div>
			<Login :url="url"></Login>
		</van-popup>
	</div>
</template>

<script>
	import Login from '@/components/login/login'

	export default {
		name: 'TradeBar',
		data() {
			return {
				active: -1,
				show: false,
				url: ''
			}
		},
		methods: {
			toQuick(path) {
				this.whatLogin((bool) => {
					if (bool) {
						this.$router.push({
							path: path
						})
					} else {
						this.show = true;
						this.url = path;
					}
				})
			}
		},
		components: {
			Login
		},
	}
</script>

<style scoped>
	.trade .van-tabbar-item {
		position: relative;
	}

	.trade .van-tabbar-img {
		height: 1rem;
		margin-bottom: 0.2rem;
	}

	.trade .van-tabbar-img img {
		position: absolute;
		top: -2.2rem;
		right: 0;
		left: 0;
		margin: auto;
		z-index: 2021;
	}

	.trade .van-tabbar-item img {
		width: 4rem;
		height: 4rem;
		border-radius: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/components/trade.vue